
import Component, { mixins } from "vue-class-component"
import { LoadState, Verzehrart } from "../../entities/common/enums"

import BestaetigenSofort from "./BestaetigenSofort.vue"
import BestaetigenAbholung from "./BestaetigenAbholung.vue"
import BestaetigenReservierung from "./BestaetigenReservierung.vue"
import Calculator from "../mixins/Calculator.vue"
import ArtikelRow from "../custom/ArtikelRow.vue"
import FilialeHeader from "../custom/FilialeHeader.vue"
import NichtGueltig from "../custom/NichtGueltig.vue"
import BestaetigenLogic from "@/logic/bestellung_neu/bestaetigen_logic"

@Component({
  components: {
    BestaetigenSofort,
    BestaetigenReservierung,
    BestaetigenAbholung,
    ArtikelRow,
    FilialeHeader,
    NichtGueltig,
  },
})
export default class BestaetigenAbholung2 extends mixins(Calculator) {
  $refs!: {
    form: HTMLFormElement
  }

  logic: BestaetigenLogic = null

  agbRules: any[] = [
    (v: boolean) => {
      if (!v) return "Bitte die AGB akzeptieren"
    },
  ]

  bezahlartRules: any[] = [
    (v: boolean) => {
      if (!v) return "Bitte Bezahlart wählen"
    },
  ]

  berechneVerzehrart() {
    switch (this.logic.abholungData.verzehrart) {
      case Verzehrart.VOR_ORT:
        return "Verzehr im Restaurant"
      case Verzehrart.MITNAHME:
        return "Zum Mitnehmen"
    }
  }

  berechneTisch() {
    if (this.logic.abholungData.tischBezeichnung) {
      return this.logic.abholungData.tischBezeichnung
    }
    return "---"
  }

  agbAnzeigen() {
    this.logic.agbAnzeigen()
  }

  get bestaetigenLoading() {
    return this.logic.bestaetigenLoadState == LoadState.LOADING
  }

  mounted() {
    this.logic = new BestaetigenLogic()
    this.logic.init()
  }

  bestellungBestaetigen() {
    var valid = this.$refs.form.validate()
    if (!valid) return

    this.logic.bestellungBestaetigen()
  }
}
